import { render, staticRenderFns } from "./ReminderShare.vue?vue&type=template&id=31cb08ec&"
import script from "./ReminderShare.vue?vue&type=script&lang=js&"
export * from "./ReminderShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports